export default "__VITE_ASSET__CKZji0rA__"